export default __webpack_public_path__ + "static/media/karen.074e37dc.svg";